import React, { useEffect, useRef, useState } from 'react';
import { Spacing } from '../../layout/Spacing/Spacing';
import { SpacingCustom } from '../../layout/Spacing/SpacingCustom';
import { PanelLayout } from '../../layout/Panel/Panel';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { rootState } from '../../../redux/store';
import { fetchChatBotResponsePading } from './chatBotResponse.slice';
import { IBlocks, IChatBotHistory, IChatBotRequestBody } from '../../../interface/interfaces';
import { addChatToHistory } from './chatBotHistory.slice';
import { useScroll } from '../../../hooks/useScroll';
import { ChatBubble } from './ChatBubble';
import { ChatIcon } from './ChatIcon';
import { ChatBotInputForm } from './ChatBotInputForm';
import ChatBotTitleBar from './ChatBotTitleBar';
import { useMeasureHeight } from '../../../hooks/useMeasureHeight';
import { ChatBotWindow } from './ChatBotWindow';
import { ChatBotIcon } from './ChatBotIcon';
import IconComponent from '../../shared/IconComponents/IconComponent';
import { TextCustom } from '../../ui/TextCustom';
import { selectorChatbot } from './redux/selector';

export const Chatbot = () => {
    const dispatch = useAppDispatch();

    
    const {loginUserAndTokenData, chat, chatHistory} = useAppSelector(selectorChatbot);
    const {userAndTokenData} = loginUserAndTokenData;
    const {chatResponseLoading, chatResponseData, chatBotResponseError } = chat;
    const {chatBotHistory} = chatHistory;


    const [chatText, setChatText] = useState<string>('');
    const [finishedChatText, setFinishedChatText] = useState('');
    const [showChat, setShowChat] = useState(false);
    const lastMessageRef = useRef<HTMLDivElement | null>(null);

    const [height1, ref1] = useMeasureHeight([showChat, chatText]);
    const [height2, ref2] = useMeasureHeight([showChat, chatText]);

    useEffect(() => {
        console.log('CHAT HISTORY: ', chatBotHistory);
    }, [chatBotHistory]);

    // add chat history to redux state 'chatBotHistory'
    // this if statement is to avoid removing chat history from local storage
    useEffect(() => {
        if (chatResponseData?.chat_history?.length > 0) {
            dispatch(addChatToHistory(chatResponseData.chat_history));
        }
    }, [chatResponseData]);

    // smooth scroll
    useScroll([chatBotHistory, finishedChatText], lastMessageRef, 'smooth');
    useScroll([showChat], lastMessageRef, 'auto');

    const submitMessage = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const body: IChatBotRequestBody = {
            message: chatText,
            set_of_contexts: ['inversum', 'neuland'],
            history: chatBotHistory,
            username: userAndTokenData?.user.username || 'Default user',
        };
        if (userAndTokenData) {
            if (chatText.trim()) {
                dispatch(
                    fetchChatBotResponsePading({
                        url: `${process.env.REACT_APP_CHAT_URL_ROOT}/chat/`,
                        token: userAndTokenData?.token,
                        body,
                    }),
                );
            }
        }

        setFinishedChatText(chatText);
        setChatText('');
    };

    const onInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setChatText(e.target.value);
    };

    const chatBotHistoryElements = chatBotHistory
        .filter((item: IChatBotHistory) => item.role === 'user' || item.role === 'assistant')
        .map((item: IChatBotHistory, idx: number) => {
            // const isSameRoleAsPrevious = idx > 0 && chatBotHistory[idx - 1]?.role === item.role; // Provera da li je prethodni item isti role
            // console.log('SAME ROLE PREVIOUS: ', isSameRoleAsPrevious)
            const formatedLabel = (item.blocks.map((item: IBlocks)=>{return item.text})).join(`\n`);
            return (
                <div key={idx} style={{ display: 'flex', paddingTop: '1rem', justifyContent: `${item.role === 'user' ? 'flex-end' : 'flex-start'}` }}>
                    {item.blocks && (
                        
                        formatedLabel
                        &&
                        <FlexCenter direction="v" position="start">
                            {item.role !== 'user' && <ChatIcon iconName="Chatbot_message" />}
                            {/* { item.role !== 'user' && !isSameRoleAsPrevious ? <ChatIcon iconName="InBot"/> : <ChatIcon background="white" iconName="InBot"/>} */}

                            <ChatBubble
                                label={formatedLabel}
                                maxWidth={250}
                                colorBorder={`${item.role === 'user' ? 'accent-green' : 'dark'}`}
                                borderIntensity={item.role === 'user' ? 0.3 : 0.05}
                                color={`${item.role === 'user' ? 'accent-green' : 'dark'}`}
                                colorIntensity={item.role === 'user' ? 0.1 : 0.06}
                                textColor="dark"
                                textSize={1.2}
                            />
                            
                        </FlexCenter>
                    )}
                </div>
            );
        });

    return (
        <>
            <ChatBotIcon setShowChat={setShowChat} />
            {showChat && (
                <ChatBotWindow>
                    <PanelLayout isRelative radius="xl">
                        <ChatBotTitleBar ref={ref1} setShowChat={setShowChat} />

                        <div style={{ width: '100%', height: `calc(100% - ${height1 + height2}px)`, overflowY: 'scroll' }}>
                            {chatBotHistory.length !== 0 ||
                                (!finishedChatText && (
                                    <div style={{ width: '100%', height: 'calc(100% - 10rem)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '1rem' }}>
                                            <div style={{ backgroundColor: 'rgba(0,0,0,.1)', width: '100px', height: '100px', borderRadius: '1.5rem' }}>
                                                <IconComponent size={10} iconName={'Chatbot_white_transparent_02'} />
                                            </div>
                                            <TextCustom color="dark" size={1.2}>
                                                Hello, how can I assist you?
                                            </TextCustom>
                                        </div>
                                    </div>
                                ))}
                            {/* <div style={{width:'100%', height: `calc(100% - ${108}px)`, overflowY: 'scroll'}}> */}

                            <Spacing marginSpacing="none" paddingSpacing="l">
                                {chatBotHistory.length !== 0 && chatBotHistoryElements}
                                {chatResponseLoading && (
                                    <>
                                        <div style={{ display: 'flex', paddingTop: '1rem', justifyContent: 'flex-end' }}>
                                            <ChatBubble
                                                label={finishedChatText}
                                                maxWidth={250}
                                                colorBorder="accent-green"
                                                borderIntensity={0.3}
                                                color="accent-green"
                                                colorIntensity={0.1}
                                                textColor="dark"
                                                textSize={1.2}
                                            />
                                        </div>
                                        <SpacingCustom paddingTop={1}>
                                            <FlexCenter direction="v" position="start">
                                                <ChatIcon iconName="Chatbot_message" />
                                                <ChatBubble
                                                    isText={false}
                                                    label={finishedChatText}
                                                    maxWidth={250}
                                                    colorBorder="dark"
                                                    borderIntensity={0.05}
                                                    color="dark"
                                                    colorIntensity={0.06}
                                                    textColor="dark"
                                                    textSize={1.2}
                                                />
                                            </FlexCenter>
                                        </SpacingCustom>
                                    </>
                                )}
                                <SpacingCustom paddingBottom={3}></SpacingCustom>
                            </Spacing>
                            <div ref={lastMessageRef}></div>
                        </div>
                        <ChatBotInputForm ref={ref2} chatResponseLoading={chatResponseLoading} chatText={chatText} submitMessage={submitMessage} onInputChange={onInputChange} />
                    </PanelLayout>
                </ChatBotWindow>
            )}
        </>
    );
};
